// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── SpeiseplanVerwaltung ─── */

.speiseplan-admin-tabs {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding: 4px 0 16px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.speiseplan-admin-tabs::-webkit-scrollbar {
  display: none;
}

.speiseplan-admin-tab {
  flex: 0 0 auto;
  padding: 8px 18px;
  border-radius: 20px;
  border: 2px solid #0074b3;
  background-color: transparent;
  color: #0074b3;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.95em;
  white-space: nowrap;
  margin: 0;
  width: auto;
  min-height: auto;
}

.speiseplan-admin-tab:hover {
  background-color: rgba(0, 116, 179, 0.1);
  opacity: 1;
}

.speiseplan-admin-tab.active {
  background-color: #0074b3;
  color: #fff;
  border-color: #0074b3;
}

/* ─── Mahlzeit-Karten ─── */

.meal-admin-cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
  animation: spFadeIn 0.2s ease;
}

@keyframes spFadeIn {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.meal-admin-card {
  background-color: rgba(180, 200, 130, 0.3);
  border-radius: 14px;
  padding: 18px 20px;
  text-align: left;
}

.meal-admin-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.meal-admin-card-header .material-symbols-outlined {
  font-size: 1.6rem;
  color: #0074b3;
}

.meal-admin-card-header h3 {
  font-size: 1.3em;
  color: #0074b3;
  margin: 0;
}

.meal-admin-card label {
  color: var(--dunkelgruen);
  font-size: 0.9em;
  margin-bottom: 4px;
}

.meal-admin-card input[type="text"] {
  background-color: rgba(180, 200, 130, 0.5);
  border: none;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 1em;
  margin-bottom: 10px;
}

.meal-admin-card input[type="text"]::placeholder {
  color: var(--primary-dark);
  opacity: 1;
}

.meal-admin-card-actions {
  display: flex;
  gap: 8px;
  margin-top: 4px;
}

.meal-admin-card-actions button {
  flex: 1 1;
  padding: 10px;
  font-size: 0.95em;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0;
  min-height: auto;
}

.meal-admin-card-actions button .material-symbols-outlined {
  font-size: 1.2rem;
}

.btn-save {
  background-color: #0074b3;
  color: #fff;
}

.btn-save:hover {
  background-color: #005f94;
}

.btn-delete {
  background-color: transparent;
  color: var(--blutorange);
  border: 2px solid var(--blutorange) !important;
}

.btn-delete:hover {
  background-color: var(--blutorange);
  color: #fff;
}

/* ─── Leerer Zustand pro Mahlzeit ─── */

.meal-admin-empty {
  color: var(--primary-dark);
  font-family: 'Circular', sans-serif;
  font-size: 0.9em;
  font-style: italic;
  margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/listen/speiseplan/SpeiseplanVerwaltung.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA,4BAA4B;;AAE5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mCAAmC;EACnC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA,wCAAwC;;AAExC;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["/* ─── SpeiseplanVerwaltung ─── */\n\n.speiseplan-admin-tabs {\n  display: flex;\n  gap: 6px;\n  overflow-x: auto;\n  padding: 4px 0 16px;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.speiseplan-admin-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.speiseplan-admin-tab {\n  flex: 0 0 auto;\n  padding: 8px 18px;\n  border-radius: 20px;\n  border: 2px solid #0074b3;\n  background-color: transparent;\n  color: #0074b3;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.95em;\n  white-space: nowrap;\n  margin: 0;\n  width: auto;\n  min-height: auto;\n}\n\n.speiseplan-admin-tab:hover {\n  background-color: rgba(0, 116, 179, 0.1);\n  opacity: 1;\n}\n\n.speiseplan-admin-tab.active {\n  background-color: #0074b3;\n  color: #fff;\n  border-color: #0074b3;\n}\n\n/* ─── Mahlzeit-Karten ─── */\n\n.meal-admin-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  animation: spFadeIn 0.2s ease;\n}\n\n@keyframes spFadeIn {\n  from { opacity: 0; transform: translateY(6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.meal-admin-card {\n  background-color: rgba(180, 200, 130, 0.3);\n  border-radius: 14px;\n  padding: 18px 20px;\n  text-align: left;\n}\n\n.meal-admin-card-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.meal-admin-card-header .material-symbols-outlined {\n  font-size: 1.6rem;\n  color: #0074b3;\n}\n\n.meal-admin-card-header h3 {\n  font-size: 1.3em;\n  color: #0074b3;\n  margin: 0;\n}\n\n.meal-admin-card label {\n  color: var(--dunkelgruen);\n  font-size: 0.9em;\n  margin-bottom: 4px;\n}\n\n.meal-admin-card input[type=\"text\"] {\n  background-color: rgba(180, 200, 130, 0.5);\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  width: 100%;\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 1em;\n  margin-bottom: 10px;\n}\n\n.meal-admin-card input[type=\"text\"]::placeholder {\n  color: var(--primary-dark);\n  opacity: 1;\n}\n\n.meal-admin-card-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.meal-admin-card-actions button {\n  flex: 1;\n  padding: 10px;\n  font-size: 0.95em;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin: 0;\n  min-height: auto;\n}\n\n.meal-admin-card-actions button .material-symbols-outlined {\n  font-size: 1.2rem;\n}\n\n.btn-save {\n  background-color: #0074b3;\n  color: #fff;\n}\n\n.btn-save:hover {\n  background-color: #005f94;\n}\n\n.btn-delete {\n  background-color: transparent;\n  color: var(--blutorange);\n  border: 2px solid var(--blutorange) !important;\n}\n\n.btn-delete:hover {\n  background-color: var(--blutorange);\n  color: #fff;\n}\n\n/* ─── Leerer Zustand pro Mahlzeit ─── */\n\n.meal-admin-empty {\n  color: var(--primary-dark);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.9em;\n  font-style: italic;\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
